// InteractionNotes.js
import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { FaChevronDown } from "react-icons/fa";
import { Menu, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import CreateInteractionNotesMd from "../../../../components/Header/modals/CreateInteractionNotes";
import MessageInteractionNotes from "../../../../components/Header/modals/MessageInteractionNotes";

const InteractionNotes = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenu, setCurrentMenu] = useState(false);
  const { selectedConvo } = useSelector((state) => state.messages);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [openCreateModal, setCreateModal] = useState(false);
  const [openMessageNotes, setOpenMessageNotes] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setCurrentMenu(false);
  };
  const openCreate = () => {
    setCreateModal(true);
    handleClose();
  };

  const openMsgNote = () => {
    setOpenMessageNotes(true);
    handleClose();
  };

  return (
    <div className="wc-chat-drop">
      <Button
        className="drop-button"
        style={{
          backgroundColor: "#fdaec9",
          color: "black",
          fontSize: "small",
        }}
        size="sm"
        onClick={handleClick}
        // disabled
      >
        <span className="drop-button-title px-2">
          Interaction Notes
          <FaChevronDown size={10} />
        </span>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={currentMenu}
        onClose={handleClose}
        PaperProps={{
          style: {
            minWidth: "120px",
            maxWidth: "200px",
          },
        }}
      >
        <MenuItem onClick={openCreate}>Add Interaction Notes</MenuItem>
        <MenuItem onClick={openMsgNote}>View Interaction Notes</MenuItem>
      </Menu>
      {openCreateModal && (
        <CreateInteractionNotesMd
          open={openCreateModal}
          handleClose={() => setCreateModal(false)}
        />
      )}
      <MessageInteractionNotes
        open={openMessageNotes}
        handleClose={() => setOpenMessageNotes(false)}
      />
    </div>
  );
};

export default InteractionNotes;
